import PageHeader from '../../components/PageHeader';
import FilterPanel from '../../components/FilterPanel';
import DataTable from '../../components/DataTable';
import { formatDate } from '../../utils/formatters';
import { Button, Typography, MenuItem, Stack, TextField } from '@mui/material';
const LOG_TYPES = {
  1: {
    label: 'שגיאה',
    className: 'error',
  },
  2: {
    label: 'אזהרה',
    className: 'warning',
  },
  3: {
    label: 'מידע',
    className: 'info',
  },
  4: {
    label: 'דיבאג',
    className: 'debug',
  },
};
const PLATFORMS = {
  1: 'API',
  2: 'BO',
  3: 'אפליקציה',
  4: 'שרת',
};
const columns = [
  {
    key: 'created',
    label: 'תאריך',
    render: (log) => formatDate(log.created),
  },
  {
    key: 'type',
    label: 'סוג',
    render: (log) => {
      const type = LOG_TYPES[log.type] || {
        label: log.type ?? '-',
        className: 'unknown',
      };
      return (
        <Typography
          sx={String(`pill log-${type.className}`)
            .split(/\s+/)
            .map(
              (name) =>
                ({
                  pill: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    minHeight: '26px',
                    borderRadius: '999px',
                    padding: '0 11px',
                    fontWeight: '800',
                    fontSize: '12px',
                    background: '#eef2f6',
                    color: '#344054',
                  },
                  'log-description': {
                    display: 'inline-block',
                    maxWidth: '720px',
                    direction: 'auto',
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'anywhere',
                  },
                  'log-error': {
                    color: '#b42318',
                    background: '#fee4e2',
                  },
                  'log-warning': {
                    color: '#b54708',
                    background: '#fef0c7',
                  },
                  'log-info': {
                    color: '#175cd3',
                    background: '#dbeafe',
                  },
                  'log-debug': {
                    color: '#5d3b9c',
                    background: '#eee5ff',
                  },
                  'log-production': {
                    color: '#067647',
                    background: '#dcfae6',
                  },
                  'log-development': {
                    color: '#475467',
                    background: '#eaecf0',
                  },
                })[name],
            )
            .filter(Boolean)}
        >
          {type.label}
        </Typography>
      );
    },
  },
  {
    key: 'platform',
    label: 'פלטפורמה',
    render: (log) => PLATFORMS[log.platform] || log.platform || '-',
  },
  {
    key: 'environment',
    label: 'סביבה',
    render: (log) => (
      <Typography
        sx={String(`pill ${log.isProduction ? 'log-production' : 'log-development'}`)
          .split(/\s+/)
          .map(
            (name) =>
              ({
                pill: {
                  display: 'inline-flex',
                  alignItems: 'center',
                  minHeight: '26px',
                  borderRadius: '999px',
                  padding: '0 11px',
                  fontWeight: '800',
                  fontSize: '12px',
                  background: '#eef2f6',
                  color: '#344054',
                },
                'log-production': {
                  color: '#067647',
                  background: '#dcfae6',
                },
                'log-development': {
                  color: '#475467',
                  background: '#eaecf0',
                },
              })[name],
          )
          .filter(Boolean)}
      >
        {log.isProduction ? 'Production' : 'Development'}
      </Typography>
    ),
  },
  {
    key: 'description',
    label: 'תיאור',
    render: (log) => (
      <Typography
        sx={{
          display: 'inline-block',
          maxWidth: '720px',
          direction: 'auto',
          whiteSpace: 'pre-wrap',
          overflowWrap: 'anywhere',
        }}
      >
        {log.description || '-'}
      </Typography>
    ),
  },
];
const LogsPage = ({ logs, filters, setFilters, loadLogs, loading }) => (
  <Stack
    sx={{
      gap: '22px',
      maxWidth: '1680px',
      height: '100%',
      overflow: 'hidden',
    }}
  >
    <PageHeader title={<>לוגים</>} meta={<>{logs.total} רשומות</>}>
      <FilterPanel>
        <TextField
          type="search"
          placeholder="חיפוש בתיאור"
          value={filters.logSearch}
          onChange={(event) =>
            setFilters({
              ...filters,
              logSearch: event.target.value,
            })
          }
          onKeyDown={(event) => event.key === 'Enter' && loadLogs(1)}
          fullWidth
        />
        <TextField
          value={filters.logType}
          onChange={(event) =>
            setFilters({
              ...filters,
              logType: event.target.value,
            })
          }
          select
          fullWidth
        >
          <MenuItem value="">כל הסוגים</MenuItem>
          {Object.entries(LOG_TYPES).map(([value, type]) => (
            <MenuItem key={value} value={value}>
              {type.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          value={filters.logPlatform}
          onChange={(event) =>
            setFilters({
              ...filters,
              logPlatform: event.target.value,
            })
          }
          select
          fullWidth
        >
          <MenuItem value="">כל הפלטפורמות</MenuItem>
          {Object.entries(PLATFORMS).map(([value, label]) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          value={filters.logEnvironment}
          onChange={(event) =>
            setFilters({
              ...filters,
              logEnvironment: event.target.value,
            })
          }
          select
          fullWidth
        >
          <MenuItem value="">כל הסביבות</MenuItem>
          <MenuItem value="production">Production</MenuItem>
          <MenuItem value="development">Development</MenuItem>
        </TextField>
        <Button type="button" onClick={() => loadLogs(1)}>
          סינון
        </Button>
      </FilterPanel>
    </PageHeader>
    <DataTable
      columns={columns}
      items={logs.items}
      rowKey={(log) => log.id || log._id}
      page={logs.page}
      limit={logs.limit}
      total={logs.total}
      onPageChange={loadLogs}
      loading={loading}
      wide
    />
  </Stack>
);
export default LogsPage;
